import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import appDisplay from 'scoreboard/components/app-display'
import i18n from 'scoreboard/components/i18n'
import StrongConfirmPrompt from 'scoreboard/components/strong-confirm-prompt'
import DependenciesPreventActionView from 'scoreboard/components/edit/dependencies-prevent-action-view'

/**
 * @param {Backbone.Model} model of the object being updated/deleted
 *
 * @param options see optionsCallback on dependencyConfirmationPrompt (below)
 *
 * @param {String} [options.messagePrefix] can be provided in place of a message
 * if the message should create a listing of `list` using the label property of each item.
 * see rollup-tree-group-panel.js for an example
 *
 * @param {Dependency[]} [options.list] list of dependencies to be displayed,
 * see options.messagePrefix
 *
 * @param {Object[]} [options.messagePrefixesAndLists] similar to messagePrefix
 * and list, but a list of pairs of messagePrefix and list. Useful when there
 * are dependencies of more than one domain object type
 *
 * @return {Backbone.View} the confirmation view
 */
function confirmationView(model, options = {}) {
	let {label = model.get('label'), message, messagePrefix, prompt,
		list, messagePrefixesAndLists} = options

	if (_.isNil(message) && (messagePrefix || messagePrefixesAndLists)) {
		if (_.isEmpty(messagePrefixesAndLists)) {
			// There's just a single messagePrefix and list, so create a list of one
			messagePrefixesAndLists = [{ messagePrefix, list }]
		}

		message = messagePrefixesAndLists.map(({ messagePrefix, list }) => {
			return '<p>' + messagePrefix + '</p>' + _createDeleteMessage(label, list)
		}).join('')
	}
	var confirmation = new StrongConfirmPrompt({
		label,
		message,
		// The message we constructed can have several paragraphs, lists, etc.
		// so we don't want to wrap it in a paragraph tag
		wrapMessageInParagraph: false,
		prompt: prompt || i18n.get('common.delete.confirmation.prompt', label),
		list
	})

	confirmation.once('confirm', () => {
		model.destroy({
			success: function (model) {
				confirmation.trigger('done')
				Backbone.trigger('delete:domain-object', model)
			},
			error: DependenciesPreventActionView.createBackboneErrorHandler()
		})
	})
	return confirmation
}

function _createDeleteMessage(label, list) {
	let message = ''
	if (!_.isEmpty(list)) {
		var makeListItem = (html, idLabel) => {
			return html + '<li>' + _.escape(idLabel.label) + '</li>'
		}
		message += `<ul>${_.reduce(list, makeListItem, '')}</ul>`
	}
	return message
}

/**
 * Displays a (strong) delete confirmation prompt for a domain object
 * that has one or more dependencies.
 *
 * @param {String} url
 * @param {Backbone.Model} model The domain object being deleted
 * @param {Function} optionsCallback passed the response from GET `url`, must return the prompt options
 * @param {Array} [optionsCallback.list] The list of dependencies
 * @param {String} [optionsCallback.label=model.label] Confirmation prompt label
 * @param {String} optionsCallback.message Confirmation prompt message
 * @param {String} [optionsCallback.prompt='common.delete.confirmation.prompt']
 * 					Confirmation prompt label
 * 					default: 'Type "delete" to delete {0}'
 */
function dependencyConfirmationPrompt(url, model, optionsCallback) {
	appDisplay.replaceDialog($.get(url), response => {
		return confirmationView(model, optionsCallback(response))
	})
}

export default dependencyConfirmationPrompt
export { confirmationView }
dependencyConfirmationPrompt.__filename__ = 'components/edit/dependency-confirmation-prompt.js'
